export enum UserDataSourceRole {
  RESEARCHER = 'researcher',
}

export interface DataSource {
  dataSourceId: string;
  name: string;
  displayName: string;
  description: string;
}

export interface DataSourceOrganization {
  dataSourceId: string;
  organizationId: string;
  rootOrganizationId: string;

  dataSourceName: string;
  dataSourceDisplayName: string;

  organizationName: string;
  organizationDisplayName: string;
  updatedAt: string;
  createdAt: string;
  archivedAt: string;
}

export interface DataSourceResearcher {
  dataSourceId: string;
  researcherId: string;
  userId: string;

  dataSourceName: string;
  dataSourceDisplayName: string;

  researcherFamilyName: string;
  researcherGivenName: string;
  researcherEmail: string;
  isManager: boolean;

  createdAt: string;
  updatedAt: string;
}

export interface DataSourceResearcherQueryDTO {
  researchers: DataSourceResearcher[];
}